import { GoogleOAuthProvider } from '@react-oauth/google';

import { GoogleButton, GoogleButtonFCProps } from './GoogleButton';
import useSocialLogin, { SocialLoginOptions } from '../../hooks/useSocialLogin';
import { Context } from '../../utils/oauth';

interface Props {
  clientId: string;
  context: Context;
  googleRedirectUri: SocialLoginOptions['googleRedirectUri'];
  onGoogleLoginClick: SocialLoginOptions['onGoogleLoginClick'];
  text?: GoogleButtonFCProps['text'];
}

const GoogleLoginWithHook: React.FC<Omit<Props, 'clientId'>> = ({
  onGoogleLoginClick,
  context,
  googleRedirectUri,
  text,
}) => {
  const { googleLogin } = useSocialLogin({
    context,
    googleRedirectUri,
    onGoogleLoginClick,
  });
  return <GoogleButton googleLogin={googleLogin} text={text} />;
};

/**
 * Used in a standalone capacity in z-web-angular
 */
const WrappedGoogleLoginHook: React.FC<Props> = ({
  clientId,
  onGoogleLoginClick,
  context,
  googleRedirectUri,
  text,
}) => (
  <GoogleOAuthProvider clientId={clientId}>
    <GoogleLoginWithHook
      onGoogleLoginClick={onGoogleLoginClick}
      context={context}
      googleRedirectUri={googleRedirectUri}
      text={text}
    />
  </GoogleOAuthProvider>
);

export default WrappedGoogleLoginHook;
